import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { API, MediumTransformationDTO } from '../../../services/api/api';
import { UtilService } from '../../../services/util.service';
import { NavigationService } from '@ngx-seatback/utils';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from '../../../services/booking.service';
import { ErrorService } from '../../../services/error.service';
import { UserService } from '../../../services/user.service';
import { PermissionService } from '../../../services/permission.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { SearchOptions } from '@ngx-seatback/controls';
import { FilterPanelConfig } from '@ngx-seatback/layout';
import { StringTransformationService } from '../../../services/transformation-helper/string-transformation.service';
import { RequestClass } from '../../../services/global/RequestClass';

@Component({
  selector: 'sb-page-medium-transformation-list',
  templateUrl: './medium-transformation-list.component.html',
  styleUrls: ['./medium-transformation-list.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediumTransformationListComponent extends RequestClass implements ModalNavigationComponent {
  public readonly api = inject(API);
  public readonly util = inject(UtilService);
  public readonly navService = inject(NavigationService);
  public readonly translate = inject(TranslateService);
  public readonly bookingService = inject(BookingService);
  public readonly errorHandler = inject(ErrorService);
  public readonly userService = inject(UserService);
  public readonly permissionService = inject(PermissionService);
  private readonly modalNavigation = inject(ModalNavigationService);
  private readonly stringTransformation = inject(StringTransformationService);
  private readonly destroyRef = inject(DestroyRef);

  // global variables
  isInModalContext: boolean;

  // table wrapper variables
  transformations: MediumTransformationDTO[] = [];

  // filter variables
  exactMatch: SearchOptions = 'contains';
  search: string | null = null;
  filterConfig: FilterPanelConfig = {
    showExactMatch: true,
    showSearchHeadline: true,
    hideTagSection: true,
    button: { visibleWithoutChanges: true },
  };

  refreshFromServer() {
    if (!this.pagination) {
      this.loading.set(false);
      return;
    }
    const sub = this.api
      .ss_nm_MediumTransformation_retrieveAll(
        {
          search: this.stringTransformation.encodeSearchQueryParamWithOptions(this.exactMatch, this.search),
        },
        this.pagination
      )
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe({
        next: (mediumTransformation: MediumTransformationDTO[]) => {
          this.transformations = mediumTransformation;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    this.subs.push(sub);
  }

  selectTransformations(transformation: MediumTransformationDTO) {
    if (this.isInModalContext) {
      this.modalNavigation.result(transformation);
    }
  }

  applyFiltering(filterMap: Map<string, any[]>) {
    this.setRequestOptions(filterMap);
    this.requestDebounced();
  }

  setRequestOptions(filterMap: Map<string, any[]>) {
    this.search = filterMap.get('search')?.[0];
    this.exactMatch = filterMap.get('exactMatch')?.[0];
  }
}
